<style lang="scss">
  .footer-min-height {
    min-height: 55px;
  }
</style>

<template>
  <div class="panel panel-default flex flex-col h-full">
    <div class="panel-heading">
      <h3 class="panel-title text-left">
        Recordatorios
      </h3>
    </div>
    <div class="panel-body flex-grow">
      <div class="tabbable-line"></div>
      <ul class="nav nav-tabs ">
        <li class="active">
          <a href="#tab_1" data-toggle="tab">Mis recordatorios</a>
        </li>
        <li>
          <a v-if="esVendedor" href="#tab_2" data-toggle="tab">
            <i class="fal fa-plus"></i> Crear recordatorio
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="tab_1">

          <h5 class="uppercase text-muted mt-8">Pendientes</h5>
          <hr class="my-6"/>

          <div v-if="recordatorios.pendientes.length > 0">
            <div v-for="pendiente in recordatorios.pendientes">
              <div class="p-4 mb-4 bg-yellow-100 border-solid border-0 border-l-4 border-yellow-500">
                <div class="text-yellow-900">
                  <div class="font-medium mb-2 text-2xl">{{ pendiente.titulo }}</div>
                  <div class="font-light small mb-2">
                    <i class="fal fa-fw fa-calendar-alt text-yellow-800"></i> Cuándo:
                    <span>{{ pendiente.fecha | prettyDate('long') }}</span>
                  </div>
                  <div class="mb-4">{{ pendiente.descripcion }}</div>
                  <div class="clearfix small text-right">
                    <a v-if="esVendedor" class="px-2 py-1 text-yellow-900 no-underline"
                       @click.prevent="completar(pendiente.id)">
                      <i title="Completar Recordatorio" class="fal fa-check-circle"></i> Marcar como completado
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="body-recordatorio">
              <div class="section-recordatorio">
                <span class="text-left">No tiene recordatorios pendiente</span>
              </div>
            </div>
          </div>

          <h5 class="uppercase text-muted mt-8">Completados</h5>
          <hr class="my-6"/>

          <div v-if="recordatorios.completados.length > 0">
            <div v-for="completado in recordatorios.completados">
              <div class="p-4 mb-4 bg-blue-100 border-solid border-0 border-l-4 border-blue-500">
                <div class="text-blue-900">
                  <div class="font-medium mb-2 text-2xl">{{ completado.titulo }}</div>
                  <div class="font-light small mb-2">
                    <i class="fal fa-fw fa-calendar-alt text-blue-800"></i> Cuándo:
                    <span>{{ completado.fecha | prettyDate('long') }}</span>
                  </div>
                  <div class="mb-4">{{ completado.descripcion }}</div>
                  <div class="clearfix small text-right">
                    <a v-show="esVendedor" class="px-2 py-1 text-blue-900 no-underline"
                       @click.prevent="pendiente(completado.id)">
                      <i title="Completar Recordatorio" class="fal fa-clock"></i> Marcar como pendiente
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="body-recordatorio">
              <div class="section-recordatorio">
                <span class="text-left">No tiene recordatorios completados</span>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane" id="tab_2">
          <!-- TASK HEAD -->
          <div class="form form-horizontal">
            <div class="form-group col-md-12">
              <img class="img-circle" width="50px"
                   :src="usuario.avatar">
              <span class="usuario-recordatorio">{{ usuario.nombre }}</span>
            </div>
            <div class="form-group col-md-12">
              <input type="text" class="form-control"
                     v-model="form.titulo"
                     name="titulo" placeholder="Título (requerido)"/>
            </div>
            <div class="form-group col-md-12">
                  <textarea class="form-control" rows="6"
                            v-model="form.descripcion" name="descripcion"
                            placeholder="Descripción (requerida)"></textarea>
            </div>
            <div class="form-group col-md-12">
              <div class="input-icon">
                <i class="fal fa-fw fa-calendar-alt"></i>
                <input class="form-control" id="fechaRecordatorio"
                       v-model="form.fecha" name="fecha_recordatorio"
                       placeholder="Fecha del recordatorio (requerido)"/>
              </div>
            </div>
            <div class="form-group col-md-12 text-right">
              <button @click.prevent="guardar()"
                      :disabled="!isValid"
                      class="btn blue-sharp">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-footer"
         v-bind:class="[ esVendedor ? 'footer-min-height' : '' ]">
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      recordableId: {type: String, required: true},
      recordableType: {type: String, required: true},
      usuario: {type: Object, required: true},
      esVendedor: {type: Boolean, required: true}
    },

    data() {
      return {
        recordatorios: {
          pendientes: [],
          completados: []
        },
        form: {
          isValid: false,
          titulo: '',
          descripcion: '',
          fecha: '',
        }
      }
    },

    computed: {
      isValid() {
        return this.form.titulo.length > 0 && this.form.descripcion.length > 0 && this.form.fecha.length > 0;
      }
    },

    methods: {
      completar(id) {
        axios.patch('api/recordatorio', {
          id,
          recordable_id: this.recordableId,
          recordable_type: this.recordableType,
          estado: 2,
        }).then(response => {
          if (response.data.recordatorio) {
            Notificaciones.showToastr('', 'Recordatorio marcado como completado', 'success');

            this.recordatorios.pendientes.forEach((recordatorio, index) => {
              if (recordatorio.id === id) {
                this.recordatorios.pendientes.splice(index, 1);
              }
            });

            this.recordatorios.completados.push(response.data.recordatorio);
          } else {
            Notificaciones.showToastr('Error', 'El recordatorio no se pudo marcar como completado', 'error');
          }
        });
      },

      pendiente(id) {
        axios.patch('api/recordatorio', {
          id,
          recordable_id: this.recordableId,
          recordable_type: this.recordableType,
          estado: 1,
        }).then(response => {
          if (response.data.recordatorio) {
            Notificaciones.showToastr('', 'Recordatorio marcado como pendiente', 'success');

            this.recordatorios.completados.forEach((recordatorio, index) => {
              if (recordatorio.id === id) {
                this.recordatorios.completados.splice(index, 1);
              }
            });

            this.recordatorios.pendientes.push(response.data.recordatorio);
          } else {
            Notificaciones.showToastr('Error', 'El recordatorio no se pudo marcar como pendiente', 'error');
          }
        });
      },

      guardar() {
        axios.post('api/recordatorio', {
          estado: 1,
          titulo: this.form.titulo,
          descripcion: this.form.descripcion,
          fecha_recordatorio: this.form.fecha,
          user_id: this.usuario.id,
          recordable_id: this.recordableId,
          recordable_type: this.recordableType,
        }).then(response => {
          if (response.data.created) {
            Notificaciones.showToastr('', 'Recordatorio guardado correctamente', 'success');

            this.recordatorios.pendientes.push(response.data.recordatorio);

            this.form.titulo = '';
            this.form.descripcion = '';
            this.form.fecha = '';
          } else {
            const message = response.data.message || 'Error al guardar el recordatorio';
            Notificaciones.showToastr('Error', message, 'error');
          }
        });
      }
    },

    created() {
      axios.get('api/recordatorio', {
        params: {
          recordable_id: this.recordableId,
          recordable_type: this.recordableType
        }
      }).then(response => {
        this.recordatorios.pendientes = response.data.recordatorios.pendientes;
        this.recordatorios.completados = response.data.recordatorios.completados;
      });
    },

    mounted() {
      const $fechaRecordatorio = $('#fechaRecordatorio');

      $fechaRecordatorio.datetimepicker({
        format: 'DD/MM/YYYY HH:mm',
        locale: 'es',
        stepping: 30
      });

      $fechaRecordatorio.on("dp.change", e => {
        if (e.date && moment(e.date).isValid()) {
          this.form.fecha = moment(e.date).format('DD/MM/YYYY HH:mm');
        } else {
          this.form.fecha = '';
        }
      });
    }
  }
</script>



// WEBPACK FOOTER //
// resources/vue/components/Recordatorios.vue